import { render, staticRenderFns } from "./waterChangeGSH.vue?vue&type=template&id=3f60ab70"
import script from "./waterChangeGSH.vue?vue&type=script&lang=js"
export * from "./waterChangeGSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports